import { render } from "./dispute-summary.vue?vue&type=template&id=390a3773&scoped=true&ts=true"
import script from "./dispute-summary.vue?vue&type=script&lang=ts"
export * from "./dispute-summary.vue?vue&type=script&lang=ts"

import "./dispute-summary.vue?vue&type=style&index=0&id=390a3773&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390a3773"]])

export default __exports__